import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StatusBadgeColourScheme } from '../../../../controls/status-badge/status-badge-constants';
import { PcmsDraftStatus } from '../../../../../shared/constants/pcms-constants';
import { SDBallotStatus } from '../../../../../shared/constants/sd-ballot.constants';
import { appConstants } from '../../../../../shared/constants/app-constants';
@Component({
    selector: 'app-public-commenting-status-badge',
    templateUrl: './public-commenting-status-badge.component.html',
    styleUrl: './public-commenting-status-badge.component.scss',
    standalone: false
})
export class PublicCommentingStatusBadgeComponent implements OnChanges {
  @Input() pcmsDraftStatus: string = '';
  statusText: string = '';
  notStart: string = appConstants.CommentAndBallotStatus.notStart;
  open: string = appConstants.CommentAndBallotStatus.open;
  closed: string = appConstants.CommentAndBallotStatus.closed;

  public statusBadgeColourSchemeEnum: StatusBadgeColourScheme = StatusBadgeColourScheme.Green;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pcmsDraftStatus']) {
      this.statusText = this.getStatusText(this.pcmsDraftStatus);
      this.statusBadgeColourSchemeEnum = this.getColourScheme(this.pcmsDraftStatus);
    }
  }

  getStatusText(draftStatus: string): string {
    switch (draftStatus) {
      case undefined:
      case null:
      case '':
      case PcmsDraftStatus.NotOpen:
        return this.notStart;
      case PcmsDraftStatus.Open:
        return this.open;
      default:
        return this.closed;
    }
  }

  getColourScheme(pcmsDraftStatus: string): StatusBadgeColourScheme {
    switch (pcmsDraftStatus) {
      case PcmsDraftStatus.Open:
        return StatusBadgeColourScheme.Green;
      default:
        return StatusBadgeColourScheme.Red;
    }
  }
}

